import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';
import { authenticatedBitswanBackendInstance } from '@/lib/api-client';

interface GlobalAdminStatusData {
  is_global_admin: boolean;
  user_id: string | null;
  email: string | null;
  name: string | null;
}

export function useGlobalAdminStatus() {
  const { user } = useAuth();

  const { data, isLoading, error } = useQuery<GlobalAdminStatusData>({
    queryKey: ['global-admin-status', user?.id],
    queryFn: async () => {
      const apiClient = await authenticatedBitswanBackendInstance();
      const response = await apiClient.get('/global-admin/status/');
      return response.data;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: false,
  });

  return {
    isGlobalAdmin: data?.is_global_admin === true,
    isLoading,
    error: error as Error | null,
  };
}
